module.exports = __webpack_public_path__ + "img/awards-winner.3019a99.webp";